// extracted by mini-css-extract-plugin
export default {"center":"mainlayout_center__zn3DD","cardCstm":"mainlayout_cardCstm__yIp+a","linkBtn":"mainlayout_linkBtn__993Ws","bannerContnt":"mainlayout_bannerContnt__wqpEk"};